import BaseAPI from './base.api';

export interface FuelData {
  absolute_fuel_litres: number;
  percentage_fuel_left: number;
  alert_level: string;
  total_refueling_litres: number;
  consumed_since_refuel: number;
  current_fuel_used: number;
  current_fuel_used_ts: number;
  fuel_used_at_refuel: number;
  fuel_used_at_refuel_ts: number;
}

export interface DeviceFuelData {
  bumperNumber: string;
  deviceId: string;
  fuelData: FuelData | null;
}

export interface LatestFuelDataResponse {
  customerId: string;
  customerCode: string;
  devices: DeviceFuelData[];
}

export default class ControlRoomAPI extends BaseAPI {
  getLatestFuelData = async (): Promise<LatestFuelDataResponse> => {
    const response = await this.API.get('control-room/get-latest-fuel-data', {
      params: { customerId: this.customerId },
    });
    return response.data;
  };
}
